import * as pdfjs from 'pdfjs-dist';
import { GlobalWorkerOptions } from 'pdfjs-dist';

export function loadPdfjsWorker() {
  let pdfWorkerSrc: string;

  const pdfJsVersion: string = pdfjs.version;
  const versionSpecificPdfWorkerUrl: string = (window as any)[
    `pdfWorkerSrc${pdfJsVersion}`
  ];

  if (versionSpecificPdfWorkerUrl) {
    pdfWorkerSrc = versionSpecificPdfWorkerUrl;
  } else if (
    typeof (window as any).pdfWorkerSrc === 'string' &&
    (window as any).pdfWorkerSrc
  ) {
    pdfWorkerSrc = (window as any).pdfWorkerSrc;
  } else {
    pdfWorkerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${
      pdfJsVersion
    }/legacy/build/pdf.worker.min.mjs`;
  }

  GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
}
